import React from 'react';
import styles from './MarkupViewer.module.scss';
import { DiffList } from './parts/DiffList';

interface Difference {
  type: 'addition' | 'deletion' | 'modification';
  customerContent?: string;
  templateContent?: string;
  section?: string;
}
interface DocumentComparison {
  differences: Difference[];
  customerText?: string;
  templateText?: string;
}

interface MarkupViewerProps {
  comparison: DocumentComparison;
  customerNDAName: string;
}

export const MarkupViewer: React.FC<MarkupViewerProps> = ({
  comparison,
  customerNDAName
}) => {
  return (
    <div className={styles.markupViewer}>
      <div className={styles.sideBySideContent}>
        <div className={styles.comparisonHeader}>
          <div className={styles.columnHeader}>
            <h4>Customer NDA</h4>
          </div>
          <div className={styles.columnHeader}>
            <h4>Zurich Template</h4>
          </div>
        </div>

        <DiffList
          differences={comparison.differences as any}
          showDifferencesOnly={true}
          activeDiffIndex={0}
        />
      </div>
    </div>
  );
};

export default MarkupViewer;
